import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { setTokenHeader, getJwtFromCookies, basePort, getRoleJwt, headers, isExpiredJwt, renderRedirect } from "../../module_auth/AuthService"
import { JobCardAdmin } from "./JobCardAdmin"

export function JobListPostReady() {
    const [objectList, setObjectList] = useState([]);
    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        if(getJwtFromCookies() == null 
            || isExpiredJwt(getJwtFromCookies()) 
            || getRoleJwt(getJwtFromCookies()) != "ROLE_ADMIN"){
            setRedirect(true)
        } else {
            setRedirect(false)
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/job_list_post_ready', 
            {method:'GET', headers,
                body:JSON.stringify()})
                .then(response => response.json())
                .then(response => {
                setObjectList(response)
            }).catch(error => console.log(error))
        }
    }, []);

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop:'10px', marginBottom:'10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>회원관리</span></li>
                            <li class="breadcrumb-item"><span>승인대기 기업회원</span></li>
                        </ol>
                    {/* end of container */}
                    </div>
                    <div class="container">
                        {objectList.map((object, index) => (
                            <JobCardAdmin object={object} index={index} key={index} returnTo={"/job_list_post_ready"}/>
                        ))}
                    </div> 
                </section>
            </main>
        </div>
    );
}